import { Link } from "@tanstack/react-router"

/**
 * The one page/section header: title + subtitle on the left, actions on the
 * right, optional back-link and chip row. `level={1}` is the desk page
 * header (mkt-page-title); `level={2}` is the admin section header
 * (mkt-section-title).
 */
export function PageHeader({
  level = 1,
  back,
  title,
  subtitle,
  chips,
  actions,
}: {
  level?: 1 | 2
  back?: { label: string; to: string }
  title: React.ReactNode
  subtitle?: React.ReactNode
  chips?: React.ReactNode
  actions?: React.ReactNode
}) {
  const heading =
    level === 1 ? (
      <h1 className="mkt-page-title">{title}</h1>
    ) : (
      <h2 className="mkt-section-title">{title}</h2>
    )
  const sub =
    subtitle == null ? null : level === 1 ? (
      <p className="mkt-page-sub">{subtitle}</p>
    ) : (
      <p className="mt-1 text-sm text-[color:var(--wf-mute)]">{subtitle}</p>
    )
  const body = (
    <div className="min-w-0">
      {back && (
        <Link to={back.to} className="mkt-event-create__back">
          ← {back.label}
        </Link>
      )}
      {heading}
      {sub}
      {chips && <div className="mt-3 flex flex-wrap gap-2">{chips}</div>}
    </div>
  )
  if (!actions) return body
  return (
    <div className="flex flex-wrap items-start justify-between gap-4">
      {body}
      <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>
    </div>
  )
}
